import Vue from 'vue';
import Router from 'vue-router';
import { sync } from 'vuex-router-sync';
import auth from '@/services/auth';
import store from '@/store';
import routes from './routes';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
});

// keep store and router in sync
sync(store, router);

// redirect to login if not authorised
router.beforeEach((to, from, next) => {
  to.meta.requiresAuth && !auth.getCurrentToken()
    ? next({
        name: 'home',
        query: {
          r: to.fullPath,
        },
      })
    : next();

  // ensure search is hidden when page is transitioning
  // but remove behind loading screen which will likely appear
  setTimeout(() => {
    store.state.chrome
      && store.dispatch('chrome/showStack', 0);
  }, 250);
});

export default router;
